module.exports = __webpack_public_path__ + "img/icon_add-01.bc2de562.svg";